import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import Image from "next/image";
import { WrapupGameMode, WrapupModulePlayedData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import pluralize from "@/src/util/pluralize";
import styles from './wrapup.module.css';

export default function WrapupModulePlaysComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.played as WrapupModulePlayedData;
    const percentWon = Math.round(data.numWon * 100 / data.numPlayed);
    const topPercent = Math.round(data.rank * 100 / data.totalUsers);

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1>Game Play</h1>
            <Image src='/images/emojis/dab.png' width={256} height={256} alt='dab' />
            <h3>
                You played <b>{pluralize(data.numPlayed, 'game')}</b> this year! Of that, you won <b>{data.numWon}</b> putting you at a {isNaN(percentWon) ? 0 : percentWon}% win rate. {percentWon > 50 ? 'Not too shabby!' : ''}
            </h3>
            <h3>Your games played rank: {data.rank} of {data.totalUsers}</h3>
            {!isNaN(topPercent) &&
                <h3>
                    That puts you in the top {topPercent}% of users this year
                </h3>
            }
            <h3>Your top game modes:</h3>
            <table>
                <thead>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td>Game Mode</td>
                        <td>Plays</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.gameModes.map(
                            (entry) => {
                                const gameMode = entry[0];
                                const gameModeName = WrapupGameMode[gameMode];
                                const count = entry[1];

                                return <tr key={gameMode}>
                                    <td>{gameModeName}</td>
                                    <td>{count}</td>
                                </tr>
                            }
                        )
                    }
                </tbody>
            </table>
        </div>
    </DialogBody>
}
